<template>
  <admin-layout :title="$t('create_x', { x: $t('Customer') })">
    <tec-form-section @submitted="submit">
      <template #title>{{ $t('create_x', { x: $t('Customer') }) }}</template>
      <template #description>{{ $t('Please fill the form below to add new record.') }}</template>

      <template #form>
        <div class="col-span-full flex items-start flex-wrap -mr-4 md:-mr-6 md:rounded-md">
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('Name')"
                v-model="form.name"
                :error="$page.props.errors.name ? $page.props.errors.name.replace('{attribute}', 'name') : null"
              />
            </div>
          </div>
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('Company')"
                v-model="form.company"
                :error="$page.props.errors.company ? $page.props.errors.company.replace('{attribute}', 'company') : null"
              />
            </div>
          </div>
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('Phone')"
                v-model="form.phone"
                :error="$page.props.errors.phone ? $page.props.errors.phone.replace('{attribute}', 'phone').split('when')[0] : null"
              />
            </div>
          </div>
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                type="email"
                :label="$t('Email')"
                v-model="form.email"
                :error="$page.props.errors.email ? $page.props.errors.email.replace('{attribute}', 'email') : null"
              />
            </div>
          </div>

          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                type="date"
                v-model="form.dob"
                :label="$t('Date of Birth')"
                :error="$page.props.errors.dob ? $page.props.errors.dob.replace('{attribute}', 'date of birth') : null"
              />
            </div>
          </div>
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('GST')"
                v-model="form.gst"
                :error="$page.props.errors.gst ? $page.props.errors.gst.replace('{attribute}', 'GST') : null"
              />
            </div>
          </div>
          <div class="w-full">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('Address')"
                v-model="form.address"
                :error="$page.props.errors.address ? $page.props.errors.address.replace('{attribute}', 'address') : null"
              />
            </div>
          </div>
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('City')"
                v-model="form.city"
                :error="$page.props.errors.city ? $page.props.errors.city.replace('{attribute}', 'city') : null"
              />
            </div>
          </div>
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('State')"
                v-model="form.state"
                :error="$page.props.errors.state ? $page.props.errors.state.replace('{attribute}', 'state') : null"
              />
            </div>
          </div>
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('Postal Code')"
                v-model="form.postal_code"
                :error="$page.props.errors.postal_code ? $page.props.errors.postal_code.replace('{attribute}', 'postal code') : null"
              />
            </div>
          </div>
          <div class="w-full sm:w-1/2">
            <div class="mr-6 mb-6">
              <text-input
                :label="$t('Country')"
                v-model="form.country"
                :error="$page.props.errors.country ? $page.props.errors.country.replace('{attribute}', 'email') : null"
              />
            </div>
          </div>
        </div>
      </template>

      <template #actions>
        <tec-action-message :on="form.recentlySuccessful" class="mr-3">{{ $t('Saved.') }}</tec-action-message>
        <loading-button :loading="form.processing" :disabled="form.processing">{{ $t('Save') }}</loading-button>
      </template>
    </tec-form-section>
  </admin-layout>
</template>

<script>
import TextInput from '@/Shared/TextInput';
import FileInput from '@/Shared/FileInput';
import AdminLayout from '@/Layouts/AdminLayout';
import LoadingButton from '@/Shared/LoadingButton';
import TecFormSection from '@/Jetstream/FormSection';
import TecActionMessage from '@/Jetstream/ActionMessage';
import TecSecondaryButton from '@/Jetstream/SecondaryButton';

export default {
  components: {
    FileInput,
    TextInput,
    AdminLayout,
    LoadingButton,
    TecFormSection,
    TecActionMessage,
    TecSecondaryButton,
  },

  data() {
    return {
      form: this.$inertia.form({
        _method: 'POST',
        name: null,
        email: null,
        phone: null,
        company: null,
        gst: null,
        vat: null,
        address: null,
        city: null,
        state: null,
        postal_code: null,
        country: null,
        dob: null,
      }),
    };
  },

  methods: {
    submit() {
      this.form.post(route('customers.store'), { preserveScroll: true });
    },
  },
};
</script>
